import React from "react";
import '../App.css';

var date = new Date();
var currYear = date.getFullYear();

// Social media links configuration
const socialMediaLinks = [
  {
    name: 'facebook',
    url: 'https://www.facebook.com/',
    icon: 'facebook'
  },
  {
    name: 'twitter',
    url: 'https://www.twitter.com/',
    icon: 'twitter'
  },
  {
    name: 'instagram',
    url: 'https://www.instagram.com/',
    icon: 'instagram'
  },
  {
    name: 'youtube',
    url: 'https://www.youtube.com/',
    icon: 'youtube'
  }
];

// Function to get SVG icon based on social media platform
const getSocialIcon = (iconType) => {
  const icons = {
    facebook: (
      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 0C4.477 0 0 4.477 0 10c0 5.013 3.693 9.153 8.505 9.876v-6.987h-2.56V10h2.56V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.129 20 14.99 20 10c0-5.523-4.477-10-10-10z"/>
      </svg>
    ),
    twitter: (
      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
        <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84"/>
      </svg>
    ),
    instagram: (
      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 0C7.287 0 6.949.012 5.905.058c-1.04.047-1.752.217-2.374.465-.644.25-1.191.586-1.738 1.133-.547.547-.883 1.094-1.133 1.738-.248.622-.418 1.334-.465 2.374C.012 6.948 0 7.287 0 10s.012 3.052.058 4.095c.047 1.04.217 1.752.465 2.374.25.644.586 1.191 1.133 1.738.547.547 1.094.883 1.738 1.133.622.248 1.334.418 2.374.465 1.044.046 1.383.058 4.095.058s3.051-.012 4.095-.058c1.04-.047 1.752-.217 2.374-.465.644-.25 1.191-.586 1.738-1.133.547-.547.883-1.094 1.133-1.738.248-.622.418-1.334.465-2.374.046-1.044.058-1.383.058-4.095s-.012-3.051-.058-4.095c-.047-1.04-.217-1.752-.465-2.374-.25-.644-.586-1.191-1.133-1.738C18.309.586 17.762.25 17.118 0c-.622-.248-1.334-.418-2.374-.465C13.052.012 12.713 0 10 0zm0 1.8c2.663 0 2.981.01 4.033.058.973.045 1.502.207 1.853.344.466.182.798.398 1.148.748.35.35.566.682.748 1.148.137.351.299.88.344 1.853.048 1.052.058 1.37.058 4.033s-.01 2.981-.058 4.033c-.045.973-.207 1.502-.344 1.853-.182.466-.398.798-.748 1.148-.35.35-.682.566-1.148.748-.351.137-.88.299-1.853.344-1.052.048-1.37.058-4.033.058s-2.981-.01-4.033-.058c-.973-.045-1.502-.207-1.853-.344-.466-.182-.798-.398-1.148-.748-.35-.35-.566-.682-.748-1.148-.137-.351-.299-.88-.344-1.853-.048-1.052-.058-1.37-.058-4.033s.01-2.981.058-4.033c.045-.973.207-1.502.344-1.853.182-.466.398-.798.748-1.148.35-.35.682-.566 1.148-.748.351-.137.88-.299 1.853-.344 1.052-.048 1.37-.058 4.033-.058z"/>
        <circle cx="10" cy="10" r="3.85" fill="currentColor"/>
        <circle cx="15.658" cy="4.342" r="0.927" fill="currentColor"/>
      </svg>
    ),
    youtube: (
      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
        <path d="M19.615 3.654a2 2 0 00-1.414-1.414C15.88 2 10 2 10 2s-5.88 0-8.201.24a2 2 0 00-1.414 1.414C0 5.875 0 10 0 10s0 4.125.171 6.346a2 2 0 001.414 1.414c2.321.24 8.201.24 8.201.24s5.88 0 8.201-.24a2 2 0 001.414-1.414C20 14.125 20 10 20 10s0-4.125-.171-6.346zM8 14V6l5.2 4-5.2 4z"/>
      </svg>
    )
  };
  
  return icons[iconType] || icons.twitter;
};

const Footer = () => {
  return (
    <React.StrictMode>
      <footer className="relative bg-gradient-to-br from-emerald-900 via-green-800 to-emerald-950 overflow-hidden">
        {/* Decorative Pattern Overlay */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M30 30c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20zm15 0c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>

        {/* Main Footer Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            
            {/* Brand Section */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-emerald-900 dark:text-emerald-200" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                  </svg>
                </div>
                <h2 className="text-3xl font-bold text-white tracking-wide">भारतशाला</h2>
              </div>
              <p className="text-emerald-100 text-lg leading-relaxed mb-6">
                भारत की सांस्कृतिक विरासत को डिजिटल रूप में संजोते हुए, हम पारंपरिक बाजारों को आधुनिक तकनीक से जोड़ते हैं।
              </p>
              <div className="flex space-x-4">
                {socialMediaLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-emerald-700 hover:bg-emerald-600 rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110"
                    aria-label={`Visit our ${social.name} page`}
                    title={`Follow us on ${social.name}`}
                  >
                    {getSocialIcon(social.icon)}
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-semibold text-white mb-6 border-b-2 border-yellow-400 pb-2">त्वरित लिंक</h3>
              <ul className="space-y-3">
                {[
                  { name: 'बाजार', href: '/markets' },
                  { name: 'श्रेणियां', href: '/categories' },
                  { name: 'खाता', href: '/account' },
                  { name: 'ऑर्डर', href: '/orders' },
                ].map((link) => (
                  <li key={link.name}>
                    <a href={link.href} className="text-emerald-100 hover:text-yellow-400 transition-colors duration-200 text-sm flex items-center group">
                      <span className="w-2 h-2 bg-yellow-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support */}
            <div>
              <h3 className="text-xl font-semibold text-white mb-6 border-b-2 border-yellow-400 pb-2">सहायता</h3>
              <ul className="space-y-3">
                {[
                  { name: 'हमारे बारे में', href: '/about' },
                  { name: 'संपर्क', href: '/contact' },
                  { name: 'सहायता केंद्र', href: '/support' },
                  { name: 'नीतियां', href: '/policies' },
                ].map((link) => (
                  <li key={link.name}>
                    <a href={link.href} className="text-emerald-100 hover:text-yellow-400 transition-colors duration-200 text-sm flex items-center group">
                      <span className="w-2 h-2 bg-yellow-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-emerald-700 my-8"></div>

          {/* Bottom Section */}
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-emerald-200 text-sm">
              &copy; {currYear} Bharatshaala Inc. सभी अधिकार सुरक्षित।
            </div>
            <div className="flex items-center space-x-6 text-sm text-emerald-200">
              <span>🇮🇳 Made in India with ❤️</span>
              <span>|</span>
              <span>डिजिटल इंडिया</span>
            </div>
          </div>
        </div>

        {/* Decorative Bottom Wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-8 text-emerald-950">
            <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="currentColor"></path>
            <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" fill="currentColor"></path>
            <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="currentColor"></path>
          </svg>
        </div>
      </footer>
    </React.StrictMode>
  );
}

export default Footer;